import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useNavigation } from '../../contexts/NavigationContext';

export default function MoreMenu({ secondaryItems }) {
  const { moreMenuOpen, closeMoreMenu } = useNavigation();
  const location = useLocation();

  // Close menu when route changes
  useEffect(() => {
    closeMoreMenu();
  }, [location.pathname, closeMoreMenu]);

  // Close menu on escape key
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') closeMoreMenu();
    };
    if (moreMenuOpen) {
      document.addEventListener('keydown', handleEscape);
      // Prevent body scroll when menu is open
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [moreMenuOpen, closeMoreMenu]);

  if (!moreMenuOpen) return null;

  return (
    <>
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-black bg-opacity-50 transition-opacity duration-300"
        style={{ zIndex: 9998 }}
        onClick={closeMoreMenu}
        aria-hidden="true"
      />

      {/* Slide-up menu */}
      <div
        className="fixed bottom-0 left-0 right-0 bg-white rounded-t-2xl shadow-2xl animate-slide-up"
        style={{ zIndex: 9999, paddingBottom: 'env(safe-area-inset-bottom)' }}
      >
        <div className="p-4">
          <div className="w-12 h-1 bg-gray-300 rounded-full mx-auto mb-4" />
          <h3 className="text-lg font-bold text-gray-900 mb-4">More</h3>

          <nav className="space-y-1">
            {secondaryItems && secondaryItems.length > 0 ? (
              secondaryItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${
                  location.pathname === item.path
                    ? 'bg-indigo-50 text-indigo-600'
                    : 'text-gray-700 hover:bg-gray-50'
                }`}
              >
                {typeof item.icon === 'string' ? (
                  <span className="text-2xl">{item.icon}</span>
                ) : (
                  <item.icon className="h-6 w-6" />
                )}
                <span className="font-medium">{item.label}</span>
              </Link>
            ))
            ) : (
              <p className="text-gray-500 text-center py-4">No additional items</p>
            )}
          </nav>

          <button
            onClick={closeMoreMenu}
            className="w-full mt-6 py-3 text-gray-600 font-medium hover:text-gray-900"
          >
            Close
          </button>
        </div>
      </div>
    </>
  );
}
